import SwapModal from './SwapModal.vue'

export default SwapModal
